import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { PurchaseInvoicesClient } from "@/features/purchaseInvoices/PurchaseInvoicesClient";
import {
  listPurchaseInvoices,
  purchaseInvoiceKeys,
} from "@/features/purchaseInvoices/purchaseInvoices.api";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Inkoopfacturen: every purchase invoice and where it stands (docs/inkoopfacturen.md).
export const Route = createFileRoute("/_shell/purchase-invoices/")({
  beforeLoad: ({ context }) => {
    const { session } = context;
    if (
      !session.roles.includes("admin") &&
      !hasModule(session, "purchase_invoices") &&
      !hasModule(session, "purchase_invoices_write")
    ) {
      throw redirect({ to: firstAllowedRoute(session) });
    }
  },
  component: PurchaseInvoicesScreen,
});

function PurchaseInvoicesScreen() {
  const { session } = Route.useRouteContext();
  const canWrite =
    session.roles.includes("admin") ||
    hasModule(session, "purchase_invoices_write");
  // Every half minute: an answer of the DataBridge moves a row without anyone touching it.
  const query = useQuery({
    queryKey: purchaseInvoiceKeys.list(),
    queryFn: listPurchaseInvoices,
    refetchInterval: 30_000,
  });
  return (
    <div
      className="wl-page wl-page--list"
      data-screen-label="Back-office Purchase Invoices"
    >
      <PurchaseInvoicesClient
        items={query.data?.items ?? []}
        userId={session.userId}
        canWrite={canWrite}
        isLoading={query.isLoading}
        isFetching={query.isFetching}
      />
    </div>
  );
}
